<template>
  <div class="configure-remote-select">
    <el-select
      ref="select"
      v-model="value"
      value-key="id"
      multiple
      filterable
      remote
      :loading="filterLoading > 0"
      :remote-method="fetchOptions"
      :placeholder="item.placeholder"
      @change="valueChange"
      clearable
      reserve-keyword
    >
      <template v-if="filterWord">
        <el-option v-for="i in filterList" :key="i.id" :label="i.name" :value="i" />
      </template>
      <el-option v-for="i in valueFilter" hidden :key="i.id" :label="i.name" :value="i" />
      <div class="case-remote-content" v-show="!filterWord">
        <el-tree
          ref="tree"
          :data="selectData"
          :props="{ isLeaf: (data) => !parentNodeIds.includes(data.id), }"
          :expand-on-click-node="false"
          @node-click="tapHandle"
          class="custom-tree"
          default-expand-all
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ data.keyAsString.length > 23 ? data.keyAsString.substring(0, 23) + '...' : data.keyAsString }}</span>
          </span>
        </el-tree>
      </div>

      <el-option hidden label="empty" value="empty" />

      <div class="configure-remote-empty-text" v-if="filterWord && filterList.length < 1 && filterLoading < 1">
        <span>暂无数据</span>
      </div>

    </el-select>
  </div>
</template>

<script>
import { services } from '@/service';

export default {
  data() {
    return {
      value: [],
      filterWord: '',
      filterList: [],
      filterLoading: 0,
      parentNodeIds: []
    };
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    selectData: {
      type: Array,
    },
  },
  watch: {
    item: {
      handler: function() {
        this.value = this.item.value;
      },
      deep: true
    }
  },
  computed: {
    valueFilter() {
      const filterIds = this.filterList.map(o => o.id);
      return this.value.filter(o => {
        return !filterIds.includes(o.id);
      });
    }
  },
  methods: {
    async fetchOptions(word = '') {
      this.filterWord = word.trim();
      if (!this.filterWord) {
        this.filterList = [];
        return;
      }
      try {
        const curFilterWord = this.filterWord;
        this.filterLoading++;
        const params = {
          from: 0,
          size: 50,
          track_total_hits: true,
          query: {
            bool: {
              must: [
                { term: { 'typename.keyword': this.item.name } },
                { match_phrase: { name: curFilterWord } }
              ]
            }
          },
          sort: [{ sort: 'asc' }]
        };
        const { hits } = await services.courseware.getCourseCrime(params);
        if (curFilterWord === this.filterWord) {
          this.filterList = hits.hits.map(o => o._source);
        }
      } catch(err) {
        this.$message.error(err.message);
      } finally {
        this.filterLoading--;
      }
    },
    tapHandle(item) {
      const idx = this.fetchIdx(item, this.value);
      if (idx === -1) {
        const obj = { id: item.id, name: item.keyAsString }
        if(this.item.key === 'category'){
          obj.type = item.children ? 'category' : 'level'
        }
        this.value.push(obj);
      } else {
        this.value.splice(idx, 1);
      }
      this.valueChange();
    },
    valueChange(){
      this.$emit('valueChange', this.item, this.value);
    },
    fetchIdx(o, value) {
      return value.findIndex(item => item.id === o.id);
    }
  }
};
</script>

<style lang="less" scoped>
.input {
  position: absolute;
  box-sizing: border-box;
  width: 100%;
  z-index: 10;
  top: 0;
  padding: 5px;
  background: #fff;
}
/deep/ .el-tree-node__content {
  height: 34px;
}

.configure-remote-empty-text {
  font-size: 14px;
  text-align: center;
  color: #4e555b;
  padding: 10px 0;
}

.configure-remote-select {
  position: relative;
  width: 100%;
  display: inline-block;

  .el-select {
    width: 100%;
  }

  .case-remote-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;

    .icon-cha {
      font-size: 14px;
      color: #172237;
      padding: 4px;
      padding-right: 0;
    }
  }

  .case-remote-content {
    box-sizing: border-box;
    position: absolute;
    background-color: #fff;
    border: 1px solid #ccd2df;
    z-index: 100;
    width: 100%;
    max-height: 200px;
    overflow: scroll;

    &::-webkit-scrollbar {
      display: none;
    }

    .select-checkbox-li {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #172237;

      .select-checkbox-li-expand {
        padding-right: 5px;
        font-size: 12px;
        color: #4e555b;
        cursor: pointer;
      }

      .select-checkbox-li-text {
        cursor: default;
        color: #585a5c;
        margin-left: 5px;
        font-size: 14px;
        flex: 1;
        width: 0;
      }
      .select-checkbox-li-icon {
        box-sizing: border-box;
        width: 18px;
        height: 18px;
        line-height: 18px;
        text-align: center;
        border: 1px solid #dbdfe9;
        border-radius: 2px;

        .icon-gou {
          font-size: 16px;
          color: #fff;
        }

        &.is-disabled {
          background: #e2e2e2;
        }
      }
      &.is-pick {
        .icon-gou {
          color: green;
        }
      }
    }
  }

  .case-bottom-tools {
    display: flex;
    padding: 10px;
    background-color: #fff;

    .normal-btn {
      flex: 1;
      width: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/loadedTreeSelect.vue